import { render, staticRenderFns } from "./ClimbingPrices.vue?vue&type=template&id=8f62fc4c&"
import script from "./ClimbingPrices.vue?vue&type=script&lang=js&"
export * from "./ClimbingPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports